import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Image } from '../ui';
import styles from './product-image-with-note.module.scss';

const ProductImageWithNote = ({ src, className = '', noteAs: Note = 'span' }) => {
    const { t } = useTranslation()

    return (
        <div className={className}>
            {src && <Image src={src} />}
            <Note className={styles.note}>
                <img className={styles.icon} src="/icons/info.svg" alt="" aria-hidden="true" />
                <i>{t('Image is for illustration.Real product may vary')}</i>
            </Note>
        </div>
    )
}

ProductImageWithNote.propTypes = {
    src: PropTypes.string,
    className: PropTypes.string,
    noteAs: PropTypes.elementType,
}

export default ProductImageWithNote
